import React from 'react';
import background1 from "@images/background1.png";
import background2 from "@images/background2.png";
import background3 from "@images/background3.png";
import background4 from "@images/background4.png";
import background5 from "@images/background5.png";
import background6 from "@images/background6.png";
import background7 from "@images/background7.png";
import background8 from "@images/background8.png";
import background9 from "@images/background9.png";
import background10 from "@images/background10.png";
import background11 from "@images/background11.png";
import background12 from "@images/background12.png";
import * as actionTypes from "@redux/actionTypes";
import { useDispatch } from 'react-redux';

const Themeitem = () => {
    const dispatch = useDispatch();

    const Themecolor = [
        {
            imgIcon: background1
        },
        {
            imgIcon: background2
        },
        {
            imgIcon: background3
        },
        {
            imgIcon: background4
        },
        {
            imgIcon: background5
        },
        {
            imgIcon: background6
        },
        {
            imgIcon: background7
        },
        {
            imgIcon: background8
        },
        {
            imgIcon: background9
        },
        {
            imgIcon: background10
        },
        {
            imgIcon: background11
        },
        {
            imgIcon: background12
        }
    ]

    const themechange = (item) => {
        const backgroundImage = item.imgIcon
        dispatch({
            type: actionTypes.THEME_ACTIVE,
            payload: backgroundImage
        })
    }

    return (
        <div className="Theme_panel">
            <div className="Themename">
                <div className="Themetext">Pick Theme</div>
            </div>
            <div className="Themeselect">
                <div className="Thememenu">
                    {
                        Themecolor.map((item, index) => {
                            return (
                                <div key={index}>
                                    <button className="Themeitems" style={{ backgroundImage: `url(${item.imgIcon})`, backgroundSize: "100% 100%", backgroundPosition: "center", backgroundRepeat: "no-repeat" }} onClick={() => themechange(item)}>
                                    </button>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default Themeitem;
